import users from './users'
import groups from './groups'
import modules from './modulues'

export default function masterData(instance) {
	return {
		users: users(instance),
		groups: groups(instance),
		modules: modules(instance)
	}
}
